import { Component } from "react";
import { BrowserRouter, Switch } from "react-router-dom";

// Containers
import { DefaultLayout } from "./containers";
import { observer } from "mobx-react";
import ErrorBoundary from "./domain/errorHandling/ErrorBoundary";
import ToastMessagesContainer from "./domain/errorHandling/ToastMessagesContainer";
import RouterToMobx from "RouterToMobx";
import { EnchargeQueryClient } from "./EnchargeQueryClient/EnchargeQueryClient";
import MuiThemeProvider from "./theme/MuiThemeProvider";

@observer
class App extends Component<{}, {}> {
  render() {
    return (
      <>
        <ToastMessagesContainer />
        <ErrorBoundary>
          {/* Inside the boundary: `createTheme` throws on a palette colour it
              cannot parse, so a bad `--dark-*` value should surface as the
              error page rather than a white screen. Nothing outside uses MUI. */}
          <MuiThemeProvider>
            <BrowserRouter>
              <RouterToMobx>
                <Switch>
                  <EnchargeQueryClient>
                    <DefaultLayout />
                  </EnchargeQueryClient>
                </Switch>
              </RouterToMobx>
            </BrowserRouter>
          </MuiThemeProvider>
        </ErrorBoundary>
      </>
    );
  }
}

export default App;
